module.exports = __webpack_public_path__ + "img/pr-4.d5829a6b.png";